import { BiBookOpen } from "react-icons/bi"
import { AiOutlineLock } from "react-icons/ai"
import { SiAdguard } from "react-icons/si"

export const FacilitiesItems = [

    {
        icon: <AiOutlineLock />,
        title: "Plata securizata",
        content: "Respectam standardul de securitate al Consiliului pentru standardele de securitate al industriei cardurilor de plati."
    },
    {
        icon: <BiBookOpen />,
        title: "Felicitare cadou",
        content: "Primești o felicitare cadou la fiecare comandă plasată!"
    },
    {
        icon: <SiAdguard />,
        title: "Calitate garantata",
        content: "Flori de calitate superioara, de la producatori certificati international"
    },
    {
        icon: <AiOutlineLock />,
        title: "Plata securizata",
        content: "Respectam standardul de securitate al Consiliului pentru standardele de securitate al industriei cardurilor de plati."
    }

]